import { ProvinceOrState } from './ProvinceOrState';

export enum ShipToEnum {
  FreightExtra = 'FREIGHT_EXTRA',
  National = 'NATIONAL',
}

export type ShipTo = ProvinceOrState | ShipToEnum;
